import { Component } from '@theme/component';

/**
 * @typedef {object} Refs
 * @property {HTMLElement} track
 */

/**
 * A lightweight horizontal scroll-snap carousel for testimonial cards.
 * The arrows are always shown (Liquid only renders them when there are
 * more cards than fit on screen); clicking one just scrolls by one card
 * width and native scroll-snap handles alignment. No visibility logic here
 * on purpose: an early or incorrect scrollWidth/clientWidth read would
 * otherwise hide the arrows.
 * @extends {Component<Refs>}
 */
export class TestimonialsCarousel extends Component {
  requiredRefs = ['track'];

  next() {
    this.#scrollByCard(1);
  }

  previous() {
    this.#scrollByCard(-1);
  }

  /** @param {1 | -1} direction */
  #scrollByCard(direction) {
    const track = this.refs.track;
    const card = track.querySelector(':scope > *');
    if (!(card instanceof HTMLElement)) return;

    const trackStyles = getComputedStyle(track);
    const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '0') || 0;
    track.scrollBy({ left: (card.offsetWidth + gap) * direction, behavior: 'smooth' });
  }
}

if (!customElements.get('testimonials-carousel')) {
  customElements.define('testimonials-carousel', TestimonialsCarousel);
}
